<template>
  <a-layout class="ucenter">
    <a-layout-sider :width="140" theme="light">
      <a-menu
          :selectedKeys="selectKey"
          :style="{height: menuHeight+'px'}" mode="inline">
        <a-menu-item :key="item.name" v-for="item in menuConfig">
          <router-link :to="{name: item.name}">
            <a-icon :type="item.icon"/>
            <span>{{ item.text }}</span>
          </router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout-content style="padding: 5px 20px;">
      <div style="font-size: 20px;">
        <a-icon :type="$route.meta.icon"/>
        <span style="margin-left: 10px;">{{ $route.meta.title }}</span>
      </div>
      <a-divider style="margin: 20px 0;"></a-divider>
      <router-view :user="user" v-if="user.id"/>
    </a-layout-content>
  </a-layout>
</template>

<script>
import api from "../../utils/api";
import func from "../../utils/func";
import layout from "../../store/layout";

export default {
  name: "UCenter",
  data() {
    return {
      user: {},
      menuConfig: []
    }
  },
  computed: {
    selectKey() {
      return layout.state.selectKey;
    },
    menuHeight() {
      return this.$store.getters["layout/contentHeight"] - 60;
    }
  },
  created() {
    require("../../router/ucenter")
        .default.forEach((route) => {
      func.hasMetaTitle(route) &&
      this.menuConfig.push({
        text: route.meta.title,
        icon: route.meta.icon,
        name: route.name,
      });
    });
  },
  mounted() {
    api.v1.user.detail().then(res => this.user = res);
  },
}
</script>

<style lang="less" scoped>
.ucenter {
  margin: 15px;
  padding: 15px 0;
  background: #fff;
}
</style>
